/**
 * KeyIcons — the icons over the words of the card's and the queue's buttons, and the cross of a
 * sheet. Task 71, from the mockup's set (`docs/design/2026-10-25-afisha/maket/maket-d4k2.html`):
 * lines 2 wide, round ends, in the colour of the word under them.
 */

import type { JSX, ReactNode } from 'react';

import type { RepeatMode } from '../store/queue';

function Line({
  className,
  children,
}: {
  readonly className: string;
  readonly children: ReactNode;
}): JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {children}
    </svg>
  );
}

export function ShuffleGlyph({ className }: { readonly className: string }): JSX.Element {
  return (
    <Line className={className}>
      <path d="M3 7h3c4 0 6 10 10 10h5M17 14l4 3-4 3M3 17h3c1.6 0 2.8-1.6 3.9-3.6M14 8.6C14.8 7.6 15.7 7 17 7h4M17 4l4 3-4 3" />
    </Line>
  );
}

export function RepeatGlyph({
  className,
  mode,
}: {
  readonly className: string;
  readonly mode: RepeatMode;
}): JSX.Element {
  return (
    <Line className={className}>
      <path d="M4 11V9a3 3 0 0 1 3-3h13M17 3l3 3-3 3M20 13v2a3 3 0 0 1-3 3H4M7 21l-3-3 3-3" />
      {mode === 'one' && <path d="M11 10h1.5v5" strokeWidth="1.5" />}
    </Line>
  );
}

/** «Наложение»: two lines crossing — one track going out as the next comes in. */
export function FadeGlyph({ className }: { readonly className: string }): JSX.Element {
  return (
    <Line className={className}>
      <path d="M3 18L21 6M3 6l7 4.5M21 18l-7-4.5" />
    </Line>
  );
}

export function MoonGlyph({ className }: { readonly className: string }): JSX.Element {
  return (
    <Line className={className}>
      <path d="M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5z" />
    </Line>
  );
}

export function TrashGlyph({ className }: { readonly className: string }): JSX.Element {
  return (
    <Line className={className}>
      <path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13" />
    </Line>
  );
}

export function CloseGlyph({ className }: { readonly className: string }): JSX.Element {
  return (
    <Line className={className}>
      <path d="M6 6l12 12M18 6L6 18" />
    </Line>
  );
}

/** The handle of a queue row: two lines to take with a finger. */
export function GrabGlyph({ className }: { readonly className: string }): JSX.Element {
  return (
    <Line className={className}>
      <path d="M5 9h14M5 15h14" />
    </Line>
  );
}
